module.exports = __webpack_public_path__ + "img/flag_122.101838d1.png";